import React from 'react'
import {MBListItem, MBUnorderedList} from '../../Atoms/Lists/MBList'
import {MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {Line} from '../../Atoms/Line'
import BucketHeader from '../../../DTO/BucketHeader'
import {BucketMemberId} from '../../../DTO/BucketMemberId'
import {BucketMemberIdContent} from './BucketMemberIdContent'

type SignedUpServiceListContentProps = {
  signedUpBucketHeaderList: BucketHeader[]
  bucketMemberIdList: BucketMemberId[]
  testId?: string
}

export const SignedUpServiceListContent: React.VFC<SignedUpServiceListContentProps> = (
  {
    signedUpBucketHeaderList,
    bucketMemberIdList,
    testId,
  },
) => {
  return (
    <MBUnorderedList data-testid={testId}>
      {signedUpBucketHeaderList.map(bucketHeader =>
        <MBListItem key={bucketHeader.id}>
          <MBContentSubTitleTypography>
            <Line>{bucketHeader.name}</Line>
            <BucketMemberIdContent
              bucketHeader={bucketHeader}
              bucketMemberIdList={bucketMemberIdList}
            />
          </MBContentSubTitleTypography>
        </MBListItem>,
      )}
    </MBUnorderedList>
  )
}
